import { CountUp } from 'countup.js/dist/countUp.min';
import isInViewport from '../util/isInViewport';

export default (function () {

  let DOM = {};

  const options = {
    separator: '',
    decimal: '',
  };

  function cacheDom() {
    DOM.items = document.querySelectorAll('[data-module="stats"]');
  }

  function bindUIActions() {
    let delay = 0;

    Array.from(DOM.items).map(function(item) {
      let value = item.dataset.to;
      let countUp = new CountUp(item, parseInt(value), options );
      delay += 150;

      // Use Intersection observer if available
      if ('IntersectionObserver' in window) {

        let observer = new IntersectionObserver(entries => {
          if(entries[0].isIntersecting){
            setTimeout(() => {
              count(countUp);
            }, delay)

            observer.unobserve(item);
          }
        });

        observer.observe(item);
      }
      // Else remplace data
      else {
        item.innerHTML = value;
      }
    });
  }

  function count(countUp) {
    if (!countUp.error) {
      countUp.start();
    } else {
      console.error(countUp.error);
    }
  }

  function init() {
    cacheDom();

    if (DOM.items && DOM.items.length > 0) {
      bindUIActions();
    }

  }

  return {
    init: init,
  }
})();

